import React from 'react';
import {
  PIXANO_APPLE_STORE_URL,
  PIXANO_GOOGLE_PLAY_URL,
  homepageSectionContainerClassName,
  sectionHeadingAccentClassName,
  storeButtonClassName,
} from '../constants/homepageUi';
import { CheckCircleIcon } from './CheckCircleRow';
import { HomepageImageGlowWrap } from './HomepageImageGlow';

/** Full asset visible (matches hero image behavior). */
const howSectionImageClassName =
  'w-full h-auto max-w-full rounded-2xl shadow-[0_8px_48px_rgba(0,0,0,0.35)]';

const ROWS = [
  'You define the environments, objects, and edge cases your models must handle in the real world',
  'Pixano launches targeted photo and video tasks across a vetted contributor network',
  'Human review plus automated checks validate, normalize, and structure every submission',
  'Approved data ships training-ready—imagery, video, and exports aligned to your labeling schema',
];

const HowPixanoWorksSection: React.FC = () => {
  return (
    <section id="data-solutions" className="scroll-mt-20 bg-[#0B0F14] pt-6 pb-16 lg:pt-8 lg:pb-[4.5rem]">
      <div className={homepageSectionContainerClassName}>
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-2 lg:gap-16 xl:gap-20">
          <div className="order-2 flex w-full min-w-0 justify-center lg:order-1">
            <HomepageImageGlowWrap className="w-full max-w-full">
              <img
                src="/assets/how-pixano-home.png"
                alt="How Pixano turns real-world capture into structured training data"
                className={howSectionImageClassName}
                decoding="async"
              />
            </HomepageImageGlowWrap>
          </div>
          <div className="order-1 flex w-full min-w-0 flex-col lg:order-2 lg:pr-2">
            <h2
              className={`text-3xl sm:text-4xl font-bold text-white tracking-tight mb-6 lg:mb-8 inline-block ${sectionHeadingAccentClassName}`}
            >
              How Pixano Works
            </h2>
            <p className="text-base sm:text-lg text-white/90 leading-relaxed mb-8 lg:mb-9">
              Pixano turns targeted real-world capture into structured training data—so your models learn from environments and edge cases that synthetic sets miss.
            </p>
            <ul className="space-y-8 lg:space-y-10 mb-9 lg:mb-10">
              {ROWS.map((item) => (
                <li key={item} className="flex gap-3.5 sm:gap-4 items-start">
                  <CheckCircleIcon className="mt-0.5" />
                  <span className="text-base sm:text-lg text-white/90 leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
            <p className="text-sm sm:text-base text-white font-medium mb-3 lg:mb-3.5">
              Download the app to start contributing
            </p>
            <div className="flex flex-row flex-wrap gap-2 sm:gap-3">
              <a
                href={PIXANO_APPLE_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={storeButtonClassName}
              >
                Apple Store
              </a>
              <a
                href={PIXANO_GOOGLE_PLAY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={storeButtonClassName}
              >
                Google Play
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowPixanoWorksSection;
